import { getUser } from './query';

class UserService {
  async getUser() {
    const result = await getUser();
    const { account } = result.data;
    const { id, identity, roles } = account;
    const { avatars } = identity;
    return {
      id,
      ...identity,
      avatarSmall: (avatars && avatars.length)
        ? `data:${avatars[0].mimeType};base64,${avatars[0].data}`
        : undefined,
      roles,
    };
  }

  static build(args) {
    return new UserService(args);
  }
}

export default UserService;
